var React = require('react');

function IconPlusInline (props) {
    return React.createElement("path",props);
}

IconPlusInline.defaultProps = {"d":"M43.6428571,26.8571429 L26.8571429,26.8571429 L26.8571429,43.6428571 C26.8571429,45.4892857 25.3464286,47 23.5,47 C21.6535714,47 20.1428571,45.4892857 20.1428571,43.6428571 L20.1428571,26.8571429 L3.35714286,26.8571429 C1.51071429,26.8571429 0,25.3464286 0,23.5 C0,21.6535714 1.51071429,20.1428571 3.35714286,20.1428571 L20.1428571,20.1428571 L20.1428571,3.35714286 C20.1428571,1.51071429 21.6535714,0 23.5,0 C25.3464286,0 26.8571429,1.51071429 26.8571429,3.35714286 L26.8571429,20.1428571 L43.6428571,20.1428571 C45.4892857,20.1428571 47,21.6535714 47,23.5 C47,25.3464286 45.4892857,26.8571429 43.6428571,26.8571429 Z"};

module.exports = IconPlusInline;

IconPlusInline.default = IconPlusInline;
